angular.module('aprima-provider-api')
    .factory('AttachmentRepository', ['AprimaRestangular', 'AprimaAnalytics', function (aprimaRestangular, AprimaAnalytics) {
        'use strict';

        var getAttachment = function (attachmentId, requestSettings, applicationComponent, disableInLinePdf) {
            var timing = AprimaAnalytics.startTiming(applicationComponent || 'AttachmentRepository', 'api', 'getAttachment');
            var inlinePDF = (disableInLinePdf) ? false : true;
        	var queryString = '?page=' + requestSettings.page + '&height=' + requestSettings.height + '&width=' + requestSettings.width + '&inLinePDF=' + inlinePDF;

            return aprimaRestangular.get().one('attachments/' + attachmentId + queryString).get().finally(timing.stop);
        };

        var getAttachmentStaticUrl = function (attachmentId, applicationComponent) {
            var timing = AprimaAnalytics.startTiming(applicationComponent || 'AttachmentRepository', 'api', 'getAttachmentStaticUrl');

            return aprimaRestangular.get().one('attachments-url/' + attachmentId).get().finally(timing.stop);
        };

        var getAttachmentRetainOriginalFormat = function (attachmentId, applicationComponent) {
            var timing = AprimaAnalytics.startTiming(applicationComponent || 'AttachmentRepository', 'api', 'getAttachmentRetainOriginalFormat');
            var queryString = '?retainoriginalformat=true';
            return aprimaRestangular.get().one('attachments/' + attachmentId + queryString).get().finally(timing.stop);
        };

        return {
            getAttachment: getAttachment,
            getAttachmentStaticUrl: getAttachmentStaticUrl,
            getAttachmentRetainOriginalFormat: getAttachmentRetainOriginalFormat
        };

    }]);
